import { render, staticRenderFns } from "./UnsubscribeRequest.vue?vue&type=template&id=24c4dcd1&scoped=true"
import script from "./UnsubscribeRequest.vue?vue&type=script&lang=js"
export * from "./UnsubscribeRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c4dcd1",
  null
  
)

export default component.exports